/**
 * PLACEHOLDER EMAILS — mirrors stepflow_core.placeholder_email: an address on a RESERVED domain (RFC 2606 / 6761 —
 * example.com|net|org, *.example, *.test, *.invalid, *.localhost) is never a real person. Older generated networks carry
 * ``supervisor@example.com``; pickers treat it as "no one selected".
 */
const RESERVED_DOMAINS = new Set(['example.com', 'example.net', 'example.org']);
const RESERVED_TLDS = ['example', 'test', 'invalid', 'localhost'];

export function isPlaceholderEmail(email) {
  const e = String(email || '').trim().toLowerCase();
  if (!e.includes('@')) return false;
  const dom = e.slice(e.lastIndexOf('@') + 1).replace(/\.$/, '');
  if (RESERVED_DOMAINS.has(dom) || dom === 'localhost') return true;
  if (RESERVED_TLDS.some((t) => dom === t || dom.endsWith(`.${t}`))) return true;
  return [...RESERVED_DOMAINS].some((d) => dom.endsWith(`.${d}`));
}
